/**
 * Copyright 2017 Control4 Corporation. All rights reserved.
 * Control4 Confidential and Proprietary Information.
 */

import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { StorageService, MonitoredHttpState, JWT_STATUS } from '@c4/core';

import { ProgrammingEventsState, EventsService } from './common/services/events.service';
import { ProgrammingUtilsService } from './common/services/utils.service';
import { ScheduleProgrammingService } from './quickstarts/quickstart-schedule/services/schedule.service';

import { SharedProgrammingService, CommonProgrammingContext } from './common/services/shared-programming.service';
import { BaseRoutingComponent } from './common/base-routing/base-routing.component';

@Component({
  selector: 'prg-programming',
  templateUrl: './programming.component.html',
  styleUrls: ['./programming.component.less'],
  providers: []
})
export class ProgrammingComponent extends BaseRoutingComponent implements OnInit {
  private events: Observable<Array<any>>;
  private scheduleEvents: Observable<Array<any>>;
  private initialized: Observable<boolean>;

  private ready: Observable<boolean>;
  private errors: Observable<Array<any>>;

  private adding: Observable<boolean>;
  private editing: Observable<boolean>;

  private _jwtStatus: Observable<JWT_STATUS>;
  private JWT_STATUS = JWT_STATUS;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected store: Store<{
      sharedProgramming: CommonProgrammingContext,
      // NOTE loosely typed here because of a potential circular dependency
      scheduleProgramming: any,
      programmingEvents: ProgrammingEventsState,
      monitoredHttpState: MonitoredHttpState
    }>,
    private utils: ProgrammingUtilsService,
    protected shared: SharedProgrammingService,
    private schedule: ScheduleProgrammingService,
    private storage: StorageService,
    // NOTE this is injected here to ensure that the list of events is populated for downstream consumers
    private eventsService: EventsService
  ) {
    super();
    this.events = this.store.select(s => s.programmingEvents.programmedEvents);
    this.scheduleEvents = this.store.select(s => s.scheduleProgramming.scheduleEvents);
    this.ready = this.store.select(s => s.sharedProgramming.ready);
    this.errors = this.store.select(s => s.sharedProgramming.errors);

    this._jwtStatus = this.store.select(s => s.monitoredHttpState.jwtStatus);

  }

  ngOnInit() {
    // console.log('programming: oninit: moduleRoot is ', this.moduleRoot);
    // share resolved module root with service so it can route if necessary
    this.shared.moduleRoot = this.moduleRoot;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/programming.component.ts